<template>
  <div class="admin-page">
    <h1 class="admin-page__title">{{ title }}</h1>

    <div class="admin-page__content">
      <ul class="admin-page__tabs">
        <li class="admin-page__tab" :class="{'admin-page__tab--active' : activeTab === 'content'}">
          <a href="#content" @click="setActiveTab('content')">Содержимое</a>
        </li>
        <li class="admin-page__tab" :class="{'admin-page__tab--active' : activeTab === 'info'}" v-if="showPartnersBlock">
          <a href="#info" @click="setActiveTab('info')">SEO/Партнёры</a>
        </li>
      </ul>
      <div class="admin-page__panel admin-page__panel--content" v-show="activeTab === 'content'">
        <slot></slot>
      </div>
      <div class="admin-page__panel admin-page__panel--info" v-if="showPartnersBlock" v-show="activeTab === 'info'">
        <page-info-block></page-info-block>
      </div>
    </div>
  </div>
</template>

<script>
  import PageInfoBlock from '../../components/PageInfoBlock';
  import {Form} from 'vform';

  export default {
    name: 'AdminCard',
    components: {
      PageInfoBlock,
    },
    data: () => ({
      activeTab: 'content',
    }),
    methods: {
      setActiveTab (tab) {
        this.activeTab = tab;
      },
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      showPartnersBlock: {
        type: Boolean,
        default: true
      },
    },
    mounted () {
      if (window.location.hash) {
        const hash = window.location.hash.replace('#', '');
        this.activeTab = hash;
      }
    }
  }
</script>
